'use client';

import { RatingStars } from '@eliadmin/core/src/components/dlz/ui/rating-stars';
import { REVIEW_COPY } from '@eliadmin/core/src/components/dlz/product-detail/reviews/review-copy';
import {
  reviewCountLabel,
  STARS,
  type ReviewStats,
} from '@eliadmin/core/src/components/dlz/product-detail/reviews/reviews';
import { useReviewFormat } from '@eliadmin/core/src/components/dlz/product-detail/reviews/use-product-reviews';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/** Figma „Summary“ (60137:5697): average, stars, count and the distribution computed from the list. */
export function ReviewSummary({ stats, className }: { stats: ReviewStats; className?: string }) {
  const format = useReviewFormat();

  return (
    <div className={cn('flex flex-col gap-4 rounded-[18px] bg-[#F5F6F7] p-4 md:p-6', className)}>
      <div className="flex items-center gap-3">
        <p className="dlz-display dlz-trim text-[#0F1012]">{format.average(stats.average)}</p>
        <div className="flex flex-col gap-1">
          <RatingStars
            value={stats.average}
            label={REVIEW_COPY.summary.rating(format.average(stats.average))}
          />
          <p className="dlz-body-s whitespace-nowrap text-[#6B7079]">
            {reviewCountLabel(stats.count)}
          </p>
        </div>
      </div>
      <ul aria-label={REVIEW_COPY.summary.distribution} className="flex flex-col gap-2">
        {STARS.map(star => {
          const count = stats.distribution[star];
          return (
            <li key={star} className="flex items-center gap-2">
              <span className="dlz-h5 w-2.5 text-[#0F1012]">{star}</span>
              <span
                aria-hidden="true"
                className="h-1.5 flex-1 overflow-hidden rounded-full bg-[#E2E4E7]"
              >
                <span
                  className="block h-full min-w-1 rounded-full bg-[#E89A0C]"
                  style={{ width: `${(count / stats.count) * 100}%`, minWidth: count ? 4 : 0 }}
                />
              </span>
              <span className="dlz-body-s w-6 text-right text-[#6B7079]">{count}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
